export default __webpack_public_path__ + "static/media/influencer-2.63c75398.webp";